import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import useSiteApp from "../../hooks/useSiteApp";

const translationPath = "components.navigationCardsPage.";

const NavigationCardsPage = () => {
  const navigate = useNavigate();

  const { config } = useSiteApp();

  const { beneficiaryCard } = config;

  const { t } = useTranslation();

  const onClickHandler = () => {
    navigate("/cards");
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack>
      <Typography variant={"subtitle1"} mb={1}>
        {t(translationPath + "title")}
      </Typography>
      <Stack
        direction={"row"}
        sx={(t) => ({
          padding: 2,
          width: "100%",
          cursor: "pointer",
          borderRadius: 4,
          color: t.palette.getContrastText(t.palette.primary.dark),
          background: `linear-gradient(to right, ${t.palette.primary.dark}, ${t.palette.primary.light})`,
        })}
        alignItems={"center"}
        onClick={onClickHandler}
        gap={2}
      >
        {beneficiaryCard && beneficiaryCard.icon.endsWith(".svg") ? (
          <ReactSVG
            beforeInjection={(svg) => {
              svg.style.height = "60px";
              svg.style.fill =
                beneficiaryCard.iconColor ??
                theme.palette.getContrastText(theme.palette.primary.dark);
            }}
            src={beneficiaryCard.icon}
          />
        ) : (
          <img
            src={
              beneficiaryCard && beneficiaryCard.icon
                ? beneficiaryCard.icon
                : "/actions/default/card.png"
            }
            alt="Ícone de cartão"
            style={{ maxWidth: !matches ? "8%" : "16%", minWidth: 70 }}
          ></img>
        )}
        <Typography variant={matches ? "subtitle1" : "body2"}>
          {t(translationPath + "action")}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NavigationCardsPage;
